export default __webpack_public_path__ + "static/media/640_dummy2016-musikschule01-mobile-de.2d92e3f1.png";